import { useEffect } from 'react';

import {
  AD_SPACE_ATTRIBUTE,
  PAID_MEMBER_STORAGE_KEY,
  PAID_MEMBER_STORAGE_VALUE
} from '@lib/ads/snack';
import type { AdSpaceChange } from '@lib/ads/snack';

/**
 * Applies getAdSpaceChange to the ad slots' space on <html>, and remembers a
 * confirmed paying member for the next page load's check before first paint
 * (FFH-3481, see openAdSpaceBeforePaint).
 */
export const useSnackAdSpace = (
  change: AdSpaceChange,
  isPaidMemberConfirmed: boolean
) => {
  useEffect(() => {
    if (change === 'keep') return;
    document.documentElement.toggleAttribute(
      AD_SPACE_ATTRIBUTE,
      change === 'open'
    );
  }, [change]);

  useEffect(() => {
    try {
      if (isPaidMemberConfirmed) {
        localStorage.setItem(
          PAID_MEMBER_STORAGE_KEY,
          PAID_MEMBER_STORAGE_VALUE
        );
      } else if (change === 'open') {
        localStorage.removeItem(PAID_MEMBER_STORAGE_KEY);
      }
    } catch {
      // With storage blocked, a member's next page opens the space before
      // first paint and closes it again once their membership arrives.
    }
  }, [change, isPaidMemberConfirmed]);
};
